<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import UserPresenter from '@satellite/components/elements/presenters/user/UserPresenter.vue';
import useYardTaskCancelledEvent from './useYardTaskCancelledEvent';

import type { YardTaskTimelineEvent } from './types';

interface Props {
  event: YardTaskTimelineEvent;
  timezone: string;
  locale: string;
}

const props = defineProps<Props>();

const { t } = useI18n();
const { formattedCreatedTime, user, reason, shouldShowReason } = useYardTaskCancelledEvent(
  props.event,
  {
    timezone: props.timezone,
    locale: props.locale
  }
);
</script>

<template>
  <div class="d-flex flex-column gap-0-5 align-start justify-start">
    <span class="d-flex flex-row flex-wrap align-center justify-start gap-1">
      <user-presenter
        v-if="user"
        class="typography-body-sm-bold text--color-text-secondary"
        :user="user"
        :display-fields="['name']" />
      <span class="typography-body-sm">{{ t('global.timeline.cancelledTheTask') }}</span>
    </span>
    <span v-if="formattedCreatedTime" class="typography-caption text--color-text-tertiary">
      {{ formattedCreatedTime }}
    </span>
    <span
      v-if="shouldShowReason"
      class="typography-body-sm text--color-text-secondary"
      data-testid="yard-task-cancelled-event-reason">
      {{ t('global.timeline.reason', { reason }) }}
    </span>
  </div>
</template>
